import { listRows } from "./listRows";
import type { ListFieldFetch } from "./types";

export const MODELS_PREFIX = "models";

export const MODELS_HELPER_TEXT = "Leave empty to allow any model.";

export function connectorAllowedModels(
  configuration: Record<string, string>
): string[] {
  return listRows(configuration, MODELS_PREFIX)
    .map((row) => row.values.name?.trim())
    .filter((name): name is string => !!name);
}

export function openAiModelsExtract(
  body: string
): Array<Record<string, string>> {
  const parsed = JSON.parse(body) as {
    data?: Array<{ id?: unknown; created?: unknown }>;
  };
  return (parsed.data ?? [])
    .filter(
      (model): model is { id: string; created?: unknown } =>
        typeof model.id === "string"
    )
    .sort((a, b) => {
      const at = typeof a.created === "number" ? a.created : null;
      const bt = typeof b.created === "number" ? b.created : null;
      if (at === null && bt === null) return 0;
      if (at === null) return 1;
      if (bt === null) return -1;
      return bt - at;
    })
    .map((model) => ({ name: model.id }));
}

export function bedrockModelsExtract(
  body: string
): Array<Record<string, string>> {
  const parsed = JSON.parse(body) as {
    modelSummaries?: Array<{ modelId?: unknown }>;
  };
  return (parsed.modelSummaries ?? [])
    .map((model) => model.modelId)
    .filter((id): id is string => typeof id === "string")
    .map((id) => ({ name: id }));
}

export function openAiModelsFetch(
  label: string,
  request: (configuration: Record<string, string>) => string
): ListFieldFetch {
  return { label, request, extract: openAiModelsExtract };
}

export function withAllowedModelsHint(
  base: string,
  configuration: Record<string, string>
): string {
  const models = connectorAllowedModels(configuration);
  return models.length
    ? `${base} Only these models may be used with this connector: ${models.join(", ")}.`
    : base;
}
